import React, { useRef, useState } from 'react';
/** lib **/
import { useInViewFadeUp } from 'lib/use-in-view';
import 'swiper/scss';
import classNames from 'classnames';
import { Concielge, FriendItemList, InsectItemList } from 'lib/friends-list';
/** components **/
import { ContentsTitle, FriendItem } from '../molecules';
/** styles **/
import s from '../../styles/organisms/friends.module.scss';
import { FriendModal } from 'components/molecules/FriendModal';
import { FriendData } from 'types/myTypes';

export const Friends: React.FC = () => {
  const inViewRef1 = useRef<HTMLHeadingElement>(null);
  const inViewRef2 = useRef<HTMLHeadingElement>(null);
  useInViewFadeUp([inViewRef1, inViewRef2]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFriend, setSelectedFriend] = useState<FriendData | null>(null);
  const handleClick = (item: FriendData) => {
    setIsModalOpen(true);
    setSelectedFriend(item);
  };

  return (
    <div className={s.friendsWrapper}>
      <div className={s.inner}>
        <div className={s.beforeFadeUp} ref={inViewRef1}>
          <ContentsTitle className={s.contentsTitle} title="FRIENDS of P-man" subTitle="ピーマンの仲間たち" />
        </div>
        <div className={s.friendListWrapper} ref={inViewRef2}>
          <div className={s.concielgeWrapper} >
            <FriendItem
              characters={Concielge.characters}
              name={Concielge.name}
              hurigana={Concielge.hurigana}
              subName={Concielge.subName}
              image={Concielge.image}
              imageWidth={Concielge.imageWidth}
              handleClick={() => handleClick(Concielge)}
            />
          </div>
          <div className={classNames(s.friendList)} ref={inViewRef2}>
            {FriendItemList.map((item, index: React.Key) => {
              return (
                <FriendItem
                  key={index}
                  characters={item.characters}
                  name={item.name}
                  image={item.image}
                  imageWidth={item.imageWidth}
                  handleClick={() => handleClick(item)}
                />
              );
            })}
          </div>
          <div className={classNames(s.insectList)} ref={inViewRef2}>
            {InsectItemList.map((item, index: React.Key) => {
              return (
                <FriendItem
                  key={index}
                  characters={item.characters}
                  name={item.name}
                  subName={item.subName}
                  image={item.image}
                  imageWidth={item.imageWidth}
                  handleClick={() => handleClick(item)}
                  className={s.insectItem}
                />
              );
            })}
          </div>
        </div>
      </div>
      {selectedFriend && (
        <FriendModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          name={selectedFriend.name}
          image={selectedFriend.image}
          hurigana={selectedFriend.hurigana ? selectedFriend.hurigana : undefined}
          subName={selectedFriend.subName ? selectedFriend.subName : undefined}
          imageWidth={selectedFriend.imageWidth}
          characters={selectedFriend.characters}
        />
      )}
    </div>
  );
};
